import { Framework } from '@/framework';
import { SizeUnitType } from '@/utils/unit-kit';
import { ILayerProps, IPoint, ISize, ResizeOperateType } from '@/version-types';
import { StageOperateImpl } from '../stage-operate';
import { historyQuickAdjustOperate } from '../type';

/**
 * 单画布舞台快速调整
 */
export class QuickAdjustOperate extends Framework {
    /** 监听快速调整 */
    onAdjust(fn: (args: { isStart: boolean; isEnd: boolean; type: ResizeOperateType }) => void) {
        return this.framework.service.events.on(historyQuickAdjustOperate, fn);
    }

    /** 触发快速调整 */
    emitAdjust(args: { isStart: boolean; isEnd: boolean; type: ResizeOperateType }) {
        this.framework.service.events.emit(historyQuickAdjustOperate, args);
        return this;
    }

    /** 写入操作记录 */
    write(originIndex: number, oldSize: ISize, newSize: ISize, unit: SizeUnitType, operateType: ResizeOperateType) {
        const isRender = this.framework.service.frame.checkFrameIsRender(originIndex);
        if (!isRender) return this;
        const extensions = this.framework.service.registration
            .getInstance<StageOperateImpl>('StageOperate')
            .collectHistoryExtensions({
                operation: 'adjust',
                originIndex,
                oldSize,
                newSize,
                unit,
                operateType,
            });
        this.framework.service.history.write({
            type: historyQuickAdjustOperate,
            data: {
                originIndex,
                oldSize,
                newSize,
                unit,
                operateType,
                extensions,
            },
        });
        return this;
    }

    /** 同步快速调整 */
    send(
        originIndex: number,
        oldSize: ISize,
        newSize: ISize,
        adjustType: ResizeOperateType,
        isStart: boolean,
        isEnd: boolean,
    ) {
        const isRender = this.framework.service.frame.checkFrameIsRender(originIndex);
        if (!isRender) return this;
        this.framework.service.history.realEdit.send(historyQuickAdjustOperate, {
            originIndex,
            oldSize,
            newSize,
            adjustType,
            isStart,
            isEnd,
        });
        return this;
    }

    /** 快速调整单图宽高 */
    doAdjust(
        originIndex: number,
        oldSize: ISize,
        newSize: ISize,
        adjustType: ResizeOperateType,
        positionMap?: Map<string, IPoint>,
    ) {
        const isRender = this.framework.service.frame.checkFrameIsRender(originIndex);
        if (!isRender) return this;
        const { width: newWidth, height: newHeight } = newSize;
        const { width: oldWidth, height: oldHeight } = oldSize;
        const renderIds = this.framework.service.frame.getLayerIds(originIndex);
        const updateLayer = (layer: ILayerProps) => {
            if (layer.children?.length) {
                layer.children.forEach((item) => {
                    updateLayer(item);
                });
            } else if (
                this.framework.service.flatLayer.checkIsBackground(layer) ||
                this.framework.service.flatLayer.checkIsMain(layer)
            ) {
                this.framework.service.behavior.get(layer)?.adjustResize?.(layer, newWidth, newHeight);
            } else {
                const offsetHeight = newHeight - oldHeight;
                const offsetWidth = newWidth - oldWidth;
                if (positionMap) {
                    const pos = positionMap.get(layer.id);
                    if (pos) {
                        if (adjustType === ResizeOperateType.TC) {
                            layer.top = ~~(pos.y + offsetHeight);
                        } else if (adjustType === ResizeOperateType.LC) {
                            layer.left = ~~(pos.x + offsetWidth);
                        }
                    }
                } else {
                    if (adjustType === ResizeOperateType.TC) {
                        layer.top = ~~(layer.top + offsetHeight);
                    } else if (adjustType === ResizeOperateType.LC) {
                        layer.left = ~~(layer.left + offsetWidth);
                    }
                }
            }
            this.framework.service.flatLayer.set(layer.id, layer, {
                updateDependencies: !layer.parentId,
                onlyUpdateBaseInfo: !this.framework.service.flatLayer.checkIsBackground(layer),
            });
        };
        for (let i = 0; i < renderIds.length; i++) {
            const layer = this.framework.service.flatLayer.getLayer(renderIds[i], true);
            if (!layer) continue;
            updateLayer(layer);
        }
        // this.framework.service.edgelessCanvas.renderAll();
        // this.framework.service.frame.rerender(originIndex);

        return this;
    }
}
